<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :block="$vuetify.breakpoint.smAndDown"
        color="success"
        v-on="on"
      >
        Create Position
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Position"
      text="Create Position Process"
      class="mb-0"
    > 
      <v-stepper
        :value="stepper"
        :vertical="false"
      >
        <v-stepper-header>
          <span
            v-for="(step,i) in steps"
            :key="i"
          >
            <v-stepper-step
              :step="i + 1"
              :complete="i+1<stepper"
            >
              {{ step.name }}
            </v-stepper-step>

            <v-divider />
          </span>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            :vertical="false"
            :step="1"
          >
            <setup-positions-stepper-form-create
              v-if="dialog"
              ref="positionForm"
              @close-dialog="closeDialog"
              @next-step="nextStep"
            />
          </v-stepper-content>

          <v-stepper-content
            :vertical="false"
            :step="2"
          >
            <setup-positions-approvals-levels-stepper-form-create
              v-if="dialog"
              ref="levelForm"
              class="elevation-3"
              @previous-step="previousStep"
              @next-step="nextStep"
            />
          </v-stepper-content>

          <v-stepper-content
            :vertical="false"
            :step="3"
          >
            <setup-positions-approvals-authorities-stepper-form-create
              v-if="dialog"
              ref="authorityForm"
              class="elevation-3"
              @previous-step="previousStep"
              @submit-form="submitForm"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      SetupPositionsStepperFormCreate: () => import('@/components/setup/positions/StepperFormCreate'),
      SetupPositionsApprovalsLevelsStepperFormCreate: () => import('@/components/setup/positions/approvals/levels/StepperFormCreate'),
      SetupPositionsApprovalsAuthoritiesStepperFormCreate: () => import('@/components/setup/positions/approvals/authorities/StepperFormCreate'),
    },
    inject: ['$validator'],
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: false,
        steps: [
          { 'name': 'Create a Position' },
          { 'name': 'Setup Approval Requirement' },
          { 'name': 'Setup Leave Authorization' },
        ],
        stepper: 1,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.stepper = 1
        }
      },
    },
    methods: {
      closeDialog () {
        this.dialog = false
      },
      nextStep () {
        this.stepper += 1
      },
      previousStep () {
        this.stepper -= 1
      },
      submitForm () {
        this.progressing = true
        let data = this.$refs.positionForm.getFormData()

        this.$api.positions().create({ 
          name: data.name,
          job_grade_id: data.job_grade_id,
        })
          .then(response => {
            let position = response.data
            this.createLevelAndAuthority(position.id)          
          })
          .catch((err) => {
            if (err.response.status === 422) {              
              this.stepper = 1
            }            
            
            this.progressing = false
          })          
      },

      createLevelAndAuthority (positionId) {
        let levelData = this.$refs.levelForm.getFormData()
        let authorityData = this.$refs.authorityForm.getFormData()

        this.$http.all([
          this.$api.positionLeaveApprovalAuthorities().update(positionId, authorityData),
          this.$api.positionLeaveApprovalLevels().update(positionId, levelData),
        ])
          .then(this.$http.spread((authority, level) => {
            if (authority.status === 200 && level.status === 200) {
              this.$snack({ message: 'Created successfully!' })
              this.$emit('created')
            }
          }))
          .then(() => {
            this.progressing = false
            this.dialog = false
          })
      },     
    },
  }
</script>
